import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxEditorModule } from 'ngx-editor';

import { OverlayModule } from '@angular/cdk/overlay';
import { GoogleAutocompleteComponent } from 'src/app/module/google-map/component/google-autocomplete/google-autocomplete.component';
import { AngularMaterialModule } from '../module/angular-material/angular-material.module';
import { ReadOnlyDirective } from '../module/order/directive/read-only.directive';
import { ProfetControlWidgetModule } from '../module/profet-control-widget/profet-control-widget.module';
import { MainNavigationComponent } from '../shared/components/main-navigation/main-navigation.component';
import { DataTableWrapperComponent } from './components/data-table-wrapper/data-table-wrapper.component';
import { FormErrorComponent } from './components/form-error/form-error.component';
import { HistoryListComponent } from './components/history-list/history-list.component';
import { InfoSheetComponent } from './components/info-sheet/info-sheet.component';
import { JsonFormComponent } from './components/json-form/json-form.component';
import { MlsAccessComponent } from './components/mls-access/mls-access.component';
import { NoContentBannerComponent } from './components/no-content-banner/no-content-banner.component';
import { OrderedListComponent } from './components/ordered-list/ordered-list.component';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { ProgressLoaderComponent } from './components/progress-loader/progress-loader.component';
import { ProgressSpinnerComponent } from './components/progress-spinner/progress-spinner.component';
import { SearchPropertyComponent } from './components/search-property/search-property.component';
import { TextEditorComponent } from './components/text-editor/text-editor.component';
import { ShowInfoDirective } from './directives/show-info.directive';
import { StandardStatusDirective } from './directives/standard_status.directive';
import { DynamicPipe } from './pipes/dynamic.pipe';
import { SelectedSourceDataPipe } from './pipes/selected-source-data.pipe';

@NgModule({
  exports: [
    StandardStatusDirective,
    CommonModule,
    DataTableWrapperComponent,
    FormErrorComponent,
    FormsModule,
    InfoSheetComponent,
    JsonFormComponent,
    MainNavigationComponent,
    PaginatorComponent,
    ProgressLoaderComponent,
    ReactiveFormsModule,
    ShowInfoDirective,
    SearchPropertyComponent,
    HistoryListComponent,
  ],
  declarations: [
    DataTableWrapperComponent,
    FormErrorComponent,
    InfoSheetComponent,
    JsonFormComponent,
    MainNavigationComponent,
    MlsAccessComponent,
    PaginatorComponent,
    ProgressLoaderComponent,
    ShowInfoDirective,
    TextEditorComponent,
    SearchPropertyComponent,
    HistoryListComponent,
  ],
  imports: [
    StandardStatusDirective,
    AngularMaterialModule,
    OverlayModule,
    CommonModule,
    FormsModule,
    NgxEditorModule,
    ProfetControlWidgetModule,
    ReactiveFormsModule,
    RouterModule,
    OrderedListComponent,
    GoogleAutocompleteComponent,
    DynamicPipe,
    SelectedSourceDataPipe,
    ProgressSpinnerComponent,
    NoContentBannerComponent,
    ReadOnlyDirective,
  ],
})
export class SharedModule {}
